import { lazy } from 'react';

// project imports
import MainLayout from 'shared/components/layout/MainLayout';
import Loadable from 'shared/components/ui-component/Loadable';
import { APPLICATION_ROUTES } from 'constants/routes';
import AdminGuard from 'shared/utils/route-guard/AdminGuard';

// sample page routing
const LocationsPage = Loadable(lazy(() => import('pages/locations')));
const LocationDetailsPage = Loadable(lazy(() => import('pages/locations/LocationDetails')));
const UsersPage = Loadable(lazy(() => import('pages/users')));
const UserDetailPage = Loadable(lazy(() => import('pages/users/UserDetails')));
const UserCreatePage = Loadable(lazy(() => import('pages/users/UserCreate')));

// ==============================|| ADMIN ROUTING ||============================== //
const AdminRoutes = {
    path: '/',
    element: (
        <AdminGuard>
            <MainLayout />
        </AdminGuard>
    ),
    children: [
        {
            path: APPLICATION_ROUTES.users.list,
            element: <UsersPage />
        },
        {
            path: APPLICATION_ROUTES.users.detail,
            element: <UserDetailPage />
        },
        {
            path: APPLICATION_ROUTES.users.create,
            element: <UserCreatePage />
        },
        {
            path: APPLICATION_ROUTES.locations.list,
            element: <LocationsPage />
        },
        {
            path: APPLICATION_ROUTES.locations.detail,
            element: <LocationDetailsPage />
        }
    ]
};

export default AdminRoutes;
